// Minimalix · animations d'apparition au scroll (progressive enhancement)
(function () {
  var root = document.documentElement;
  root.classList.add('mx-anim');
  var SELECTORS = [
    '.mx-hero__text', '.mx-hero__visual',
    '.mx-featured__head', '.mx-card',
    '.mx-rea__item',
    '.mx-cols__head', '.mx-col',
    '.mx-story__media', '.mx-story__text'
  ];
  var els = [];
  SELECTORS.forEach(function (s) {
    document.querySelectorAll(s).forEach(function (el) { els.push(el); });
  });
  if (!('IntersectionObserver' in window) || !els.length) {
    els.forEach(function (el) { el.classList.add('is-in'); });
    return;
  }
  els.forEach(function (el, i) {
    el.classList.add('mx-reveal');
    el.style.transitionDelay = (Math.min(i % 6, 5) * 60) + 'ms';
  });
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
  els.forEach(function (el) { io.observe(el); });
})();
